import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, errText } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      localStorage.setItem("jt_admin_token", data.token);
      nav("/admin");
    } catch (ex) {
      setErr(errText(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin min-h-screen bg-neutral-100 flex items-center justify-center p-6">
      <meta name="robots" content="noindex" />
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-3xl p-8 shadow-sm space-y-4" data-testid="admin-login-form">
        <div>
          <div className="admin-brand text-3xl">joetanis.com</div>
          <p className="text-sm text-neutral-500 mt-1">Site admin</p>
        </div>
        <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
        <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
        {err && <p className="text-sm text-red-600" data-testid="admin-login-error">{err}</p>}
        <Button type="submit" disabled={busy} className="w-full rounded-full h-11" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
